module.exports = __webpack_public_path__ + "img/logo_front.79d51458.png";